// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_FranchiseIdInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for payroll period action endpoints requiring only franchise_id
 *
 * Shared by:
 * - POST /payroll/pay_period/{id}
 * - POST /payroll/reverse_period/{id}
 * - POST /payroll/undo_period/{id}
 * - POST /payroll/archive_period/{id}
 * - POST /payroll/confirm_period/{id}
 * - POST /payroll/mark_period_calculated/{id}
 */
import { registerContract } from './validate'

export interface Payroll_FranchiseIdInput {
franchise_id: number
}

registerContract('Payroll_FranchiseIdInput', {
  franchise_id: { type: 'number',  required: true },
})
